<template>
    <div>
        <div class="order-title-wrap mt10" v-if="flag">
            <div class="swb-back-row">
                <div class="order-title mb10">
                    <div class="order-title-content fl">
                        <ul class="order-status">
                            <li class="">供应商名称：{{contranct.sndPartyName}}</li>
                            <li class="">系统合同编号：{{contranct.no}}</li>
                            <li>支付方式:{{contranct.payWayName}}</li>
                            <li v-if="contranct.confirmed && !contranct.fullfilled" class="">合同状态：履约中</li>
                            <li v-if="contranct.fullfilled && !contranct.checked" class="">合同状态：履约完成</li>
                            <li v-if="contranct.checked" class="">合同状态：已验收</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="block-container mt10">
            <div class="swb-back-row">
                <swb-goods-order-search class="mb10" :no="no" :isContract="true" :contractId="contractId" ref="query_model" @showSearch="searchMethod"></swb-goods-order-search>
                <div class="order-search-container">
                    <a class="all-order">全部订单</a>
                </div>
                <div class="orders-list-container">
                    <table class="orders-list-panel1">
                        <colgroup>
                            <col width="550">
                            <col width="200">
                            <col width="150">
                            <col width="100">
                            <col width="100">
                            <col width="100">
                        </colgroup>
                        <thead class="orders-header">
                        <tr class="">
                            <th>订单详情</th>
                            <th>收货信息</th>
                            <th>金额</th>
                            <th>交易状态</th>
                            <th>交付状态</th>
                            <th>操作</th>
                        </tr>
                        </thead>
                        <tbody class="orders-body" v-if="goodsOrderList != null && goodsOrderList.length > 0" v-for="(goodsOrder, index) in goodsOrderList">
                        <tr class="blank-row">
                            <td colspan="6"></td>
                        </tr>
                        <tr class="abstract-row">
                            <td colspan="6">
                                <div class="abstract-content">
                                    <span class="mr10">订单号：<a>{{goodsOrder.no}}</a></span>
                                    <span class="mr10">合同单号：<a>{{goodsOrder.contractNo}}</a></span>
                                    <!--<span class="mr5">交易单号：<a class="swb-btn-link" @click="toTradeVoucherList(goodsOrder.tradeNo,goodsOrder.contractNo)">{{goodsOrder.tradeNo}}</a></span>-->
                                    <span class="mr10">{{goodsOrder.createTime}}</span>
                                    <span class="mr10">商家名称：{{goodsOrder.buyerComName}}</span>
                                    <span v-if="goodsOrder.trackPhaseName != null" class="mr10">计划阶段：{{goodsOrder.trackPhaseName}}</span>
                                    <el-tag :type="goodsOrder.manualAllocFlag ? 'success' : 'danger'">{{goodsOrder.manualAllocFlag ? '手工配货' : '自动配货'}}</el-tag>
                                    <el-tag v-if="goodsOrder.cgVoucherId != -1" class="success">请购</el-tag>
                                </div>
                                <div v-if="goodsOrder.proxied" class="table-tips order"></div>
                            </td>
                        </tr>
                        <tr class="info-row">
                            <td>
                                <div class="goods-info-block mt10" v-if="goodsOrder.itemList != null && goodsOrder.itemList.length > 0" v-for="(goodsOrderItem, index) in goodsOrder.itemList">
                                    <div class="goods-item clearfix">
                                        <div class="good-img">
                                            <img class="wh100" :src="goodsOrderItem.skuDefaultImageUrl"/>
                                        </div>
                                        <div class="good-msg">
                                            <p class="ellipsis-2 font12 align-left">
                                                <span>{{goodsOrderItem.title}}</span>&nbsp;&nbsp;
                                                <span v-if="goodsOrderItem.skuSpecVals != null && goodsOrderItem.skuSpecVals.length > 0" v-for="(skuSpecVal, index) in goodsOrderItem.skuSpecVals">
                                                {{skuSpecVal.specName}}：{{skuSpecVal.specVal}}&nbsp;&nbsp;
                                                </span>
                                            </p>
                                            <p class="mt5 align-left">
                                                <span>品牌：</span>
                                                <span>{{goodsOrderItem.brandName}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="goods-number font-gray1">x {{goodsOrderItem.quantity}}</div>
                                    <div class="clr"></div>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <!--改为零售商的联系方式-->
                                    <div class="font14">联系人：{{goodsOrder.buyerComContactName}}</div>
                                    <div class="font14">联系方式：{{goodsOrder.buyerComContactTel}}</div>
                                </div>
                            </td>
                            <td>
                                <div class="font-gray1">
                                    <div class="font14 font-gray2">总额：¥{{goodsOrder.totalAmount}}</div>
                                </div>
                            </td>
                            <td>
                                <div class="font14 font-gray2">{{goodsOrder.state}}</div>
                                <div class="swb-btn-link" v-if="checkActionPerm('view_detail')" @click="toGoodsOrderInfo(goodsOrder.id, goodsOrder.manualAllocFlag, goodsOrder.cancelled)">
                                    <i class="icon iconfont"></i><span>订单详情</span>
                                </div>
                            </td>
                            <td>
                                <div class="font14 font-gray2" v-if="goodsOrder.shipState==0">未发货</div>
                                <div class="font14 font-gray2" v-if="goodsOrder.shipState==1 && goodsOrder.recvState==0">已部分发货</div>
                                <div class="font14 font-gray2" v-if="goodsOrder.shipState==1 && goodsOrder.recvState==1">已部分收货</div>
                                <div class="font14 font-gray2" v-if="goodsOrder.shipState==1 && goodsOrder.recvState==2">已全部收货</div>
                                <div class="font14 font-gray2" v-if="goodsOrder.shipState==2 && goodsOrder.recvState==0">已全部发货</div>
                                <div class="font14 font-gray2" v-if="goodsOrder.shipState==2 && goodsOrder.recvState==1">已部分收货</div>
                                <div class="font14 font-gray2" v-if="goodsOrder.shipState==2 && goodsOrder.recvState==2">已全部收货</div>
                                <!--<div class="font14 font-gray2"> <span class="mr30">{{shipStateInfo[goodsOrder.shipState]}}</span></div>-->
                            </td>
                            <td>
                                <div v-if="checkActionPerm('cancel')&& goodsOrder.proxied && !goodsOrder.cancelled && goodsOrder.shipState == 0 && !contranct.closed">
                                    <a @click="doCancelGoodsOrderById(goodsOrder.id);" class="swb-btn-link">取消</a>
                                </div>
                                <div v-if="!contranct.closed">
                                    <a class="swb-btn swb-btn-link" v-if="checkActionPerm('initiate_complaint')" @click="complaintSave(goodsOrder.id)">发起投诉</a>
                                    <a class="swb-btn swb-btn-link" v-if="checkActionPerm('allocation_of_cargo') && !goodsOrder.cancelled" @click="toPeiHuo(goodsOrder.id)">去配货</a>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="block pagination-layout">
                    <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                </div>
            </div>
        </div>
        <div class="form-toolbar" v-if="flag">
            <button class="swb-btn swb-btn-small swb-btn-primary" @click="prevContract">返回</button>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import contractApi from '../../api/contract'
    import goodsOrderApi from '../../api/goodsOrder'
    import { openPageRouteUrl, getDefaultPageSizes } from '../../app.conf';
    import { checkUserActionPerm } from '../index'

    import SwbShowGoodsOrder from './ShowGoodsOrder';
    Routes.add(SwbShowGoodsOrder);

    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';
    Routes.add(SwbTradeVoucherList);
    import SwbComplaintSave from '../custsvc/ComplaintSave';
    Routes.add(SwbComplaintSave);

    import SwbGoodsOrderSearch from './GoodsOrderSearch';
    Vue.regist(SwbGoodsOrderSearch);

    function checkVueActionPermWithCache(action, targetPostId) {
        this.userActionPermCache = this.userActionPermCache || {};
        //
        let cacheKey = (action == null ? "" : action) + "::" + (targetPostId == null ? "" : targetPostId);
        let cacheValue = this.userActionPermCache[cacheKey];
        if(cacheValue == null) {
            //原生调用
            cacheValue = checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            this.userActionPermCache[cacheKey] = cacheValue;
        }
        return cacheValue;
    }

    export default {
        name: 'swb-goods-order-list',
        path: '/goods/order/list',
        pathOld: '/servc/goods/order/list',
        avlActions: 'view_detail|cancel|initiate_complaint|allocation_of_cargo',
        avlScopes: 'servicer',
        desc: '商品订单列表',
        helpArticleCode: 'servicer-goods-order-list-contract',
        authen: false,
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                contractId: null,
                contranct: {},
                no: this.$route.query.no || null,
                goodsOrderList: [],
                flag: false,
                offlinePayWay: {},
                unionpayPayWay: {},
                recvStateInfo: {},
                shipStateInfo: {},
                searchShow: null,
                generalVoucherType: {},
                contractVoucherType: {}
            }
        },
        watch: {
            '$route': 'fetchData'
        },
        created: function () {
            //
            this.pageSize = this.pageSizes.first();
            //
            this.generalVoucherType = getEnumInfoWith("tradeVoucherType", 'name', 'GeneralVoucher');
            this.contractVoucherType = getEnumInfoWith("tradeVoucherType", 'name', 'ContractVoucher');
            //
            this.fetchData();
        },
        methods: {
            //
            searchMethod: function (queryModel) {
                //
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.toGetGoodsOrderList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkVueActionPermWithCache.call(this, action, targetPostId);
                //return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            showSearch: function (flag) {
                this.searchShow = flag;
            },
            // 跳转交易单列表
            toTradeVoucherList: function (tradeNo, contractNo) {
                let generalVoucher = this.generalVoucherType.value;
                if(contractNo != null) {
                    generalVoucher = this.contractVoucherType.value;
                }
                let data = {no: tradeNo, tradeVoucherType: generalVoucher};
                let hashUrl = Utils.makeUrl(SwbTradeVoucherList.path, data);
                openPageRouteUrl(null, "/bench/home", hashUrl);
            },

            fetchData: function () {
                let contractId = this.$route.query.contractId || null;
                if(contractId != null) {
                    this.getContractById(contractId);
                    this.flag = true;
                } else {
                    this.flag = false;
                }
                let no = this.$route.query.no || null;
                if(!Utils.isNoB(no)) {
                    this.no = no;
                    this.queryModel.filterItems.no = no;
                }
                this.contractId = contractId;
                this.offlinePayWay = getEnumInfoWith("payWay", 'name', 'Offline');
                this.unionpayPayWay = getEnumInfoWith("payWay", 'name', 'Unionpay');
                this.recvStateInfo = getEnumMap('recvState', 'value2text');
                this.shipStateInfo = getEnumMap('shipState', 'value2text');
                //
                this.toGetGoodsOrderList();
            },
            prevContract: function () {
                let self = this;
                self.$router.back(-1);
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.toGetGoodsOrderList();
            },
            getContractById: function (contractId) {
                let self = this;
                let postData = {};
                postData.id = contractId;
                //
                contractApi.getContractInfo(postData, function (result) {
                    if(result.type == "info") {
                        self.contranct = result.data;
                    }
                });
            },
            toGetGoodsOrderList: function () {
                let self = this;
                let contractId = self.$route.query.contractId || null;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };

                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.isContract = true;
                filterItems.contractId = contractId;
                filterItems.deliverType = getEnumInfoWith("deliverType", 'name', 'Normal').value;
                filterItems.ioFlag = 1;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;

                //
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getGoodsOrderList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == "info") {
                        let offlinePayWay = self.offlinePayWay;
                        let unionpayPayWay = self.unionpayPayWay;
                        let goodsOrderList = result.data.rows;
                        if(goodsOrderList != null && goodsOrderList.length > 0) {
                            for(var i = 0; i < goodsOrderList.length; i++) {
                                let goodsOrder = goodsOrderList[i];
                                if(offlinePayWay.value == goodsOrder.payWay) {
                                    goodsOrder.payWayName = offlinePayWay.text
                                } else {
                                    goodsOrder.payWayName = unionpayPayWay.text
                                }
                            }
                        }
                        self.goodsOrderList = goodsOrderList;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 商品订单详情
            toGoodsOrderInfo: function (id, manualAllocFlag, cancelled) {
                let pushDate = {};
                pushDate.path = SwbShowGoodsOrder.path;
                if(id != null) {
                    pushDate.query = {goodsOrderId: id, manualAllocFlag: manualAllocFlag, cancelledFlag: cancelled};
                }
                this.$router.push(pushDate);
            },
            // 发起投诉
            complaintSave: function (orderId) {
                let subjectType = getEnumInfoWith("complaintSubjectType", "name", "GoodsOrder");
                //
                this.$router.push({
                    path: SwbComplaintSave.path,
                    query: {
                        orderId: orderId,
                        subjectType: subjectType.value
                    }
                })
            },
            // 订单操作
            doCancelGoodsOrderById: function (orderId) {
                let self = this;
                self.$prompt('请输入取消原因', '取消确认对话框', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(function (data) {
                    let cancelCause = data.value;
                    //
                    let postData = {};
                    postData.orderId = orderId;
                    postData.cancelCause = cancelCause;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    goodsOrderApi.doCancelGoodsOrder(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type == "info") {
                            MsgBox.info("操作成功");
                            self.toGetGoodsOrderList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            // 去配货
            toPeiHuo: function (orderId) {
                this.$router.push({
                    path: SwbShowGoodsOrder.path,
                    query: {
                        activeName: "second",
                        goodsOrderId: orderId
                    }
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/order/GoodsOrderList.vue